import { useQuery } from '@tanstack/vue-query'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { getKycPendingStatusCounts } from '../investorsEndpoints'

export function useKycPendingStatusCountsQuery() {
  return useQuery({
    queryKey: investorsQueryKeys.kycPendingStatusCounts(),
    queryFn: getKycPendingStatusCounts,
    staleTime: 1000 * 30,
  })
}
